import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1100px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold mb-3">
              深度内容
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              独家解读与数据报告
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3">
              每日大赛原创深度内容，用数据透视娱乐PK背后的故事
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {mediaData.map((item) => (
              <article
                key={item.id}
                className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
              >
                <div className="relative overflow-hidden aspect-video">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-background-50/90 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                      <i className="ri-play-fill text-xl text-primary-500 group-hover:text-background-50 transition-colors"></i>
                    </div>
                  </div>
                </div>
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <div className="text-xs text-foreground-500 mb-2">{item.source}</div>
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                    {item.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}